import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['startDate', 'endDate', 'link'];

  connect() {
    // Optional: Set default dates or read from URL if present
  }

  updateLink() {
    const url = new URL(
      this.linkTarget.getAttribute('href'),
      window.location.origin
    );
    const startDate = this.startDateTarget.value;
    const endDate = this.endDateTarget.value;

    if (startDate) {
      url.searchParams.set('start_date', startDate);
    } else {
      url.searchParams.delete('start_date');
    }

    if (endDate) {
      url.searchParams.set('end_date', endDate);
    } else {
      url.searchParams.delete('end_date');
    }

    this.linkTarget.setAttribute('href', url.toString());
  }
}
